import { render, staticRenderFns } from "./RecordsFilterDialog.vue?vue&type=template&id=44126b45&scoped=true"
import script from "./RecordsFilterDialog.vue?vue&type=script&lang=js"
export * from "./RecordsFilterDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordsFilterDialog.vue?vue&type=style&index=0&id=44126b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44126b45",
  null
  
)

export default component.exports